import type { MailPlanOp } from "@kwp/contracts";

/** What a bulk op did, for its toast ("Archived: 12 messages."). */
export function describeBulkOp(op: MailPlanOp): string {
  switch (op.kind) {
    case "archive":
      return "Archived";
    case "unarchive":
      return "Moved to the inbox";
    case "read":
      return "Marked read";
    case "unread":
      return "Marked unread";
    case "star":
      return "Starred";
    case "unstar":
      return "Unstarred";
    case "spam":
      return "Reported as spam";
    case "notSpam":
      return "Marked not spam";
    case "trash":
      return "Moved to trash";
    case "untrash":
      return "Restored";
    case "addTags":
      return `Tagged ${op.tags.join(", ")}`;
    case "removeTags":
      return `Untagged ${op.tags.join(", ")}`;
    case "moveToFolder":
      return `Moved to ${op.folder}`;
  }
}

/** The bulk bar's buttons, in order; tag and move ask for a name first. */
export const BULK_OPS: ReadonlyArray<{ key: string; label: string; op: MailPlanOp | "tag" | "move" }> = [
  { key: "archive", label: "Archive", op: { kind: "archive" } },
  { key: "read", label: "Mark read", op: { kind: "read" } },
  { key: "unread", label: "Mark unread", op: { kind: "unread" } },
  { key: "star", label: "Star", op: { kind: "star" } },
  { key: "tag", label: "Tag…", op: "tag" },
  { key: "move", label: "Move…", op: "move" },
  { key: "spam", label: "Spam", op: { kind: "spam" } },
  { key: "trash", label: "Trash", op: { kind: "trash" } },
];
